import { initializeApp } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

// Debug logging to verify environment variables are loaded
//console.log("=== FIREBASE CONFIG INITIALIZATION ===");
//console.log("Environment variables available:", {
//  VITE_ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
//  API_KEY_EXISTS: !!import.meta.env.VITE_FIREBASE_API_KEY,
//  AUTH_DOMAIN_EXISTS: !!import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
//  PROJECT_ID_EXISTS: !!import.meta.env.VITE_FIREBASE_PROJECT_ID,
//  STORAGE_BUCKET_EXISTS: !!import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
//  MESSAGING_SENDER_ID_EXISTS: !!import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
//  APP_ID_EXISTS: !!import.meta.env.VITE_FIREBASE_APP_ID
//});

// Check if Firebase credentials are valid (not the placeholder values)
const hasValidFirebaseConfig = () => {
  const apiKey = import.meta.env.VITE_FIREBASE_API_KEY;
  const authDomain = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
  const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

  // Check if the required values exist and aren't the placeholder values
  return (
    apiKey &&
    apiKey !== 'your_api_key_here' &&
    authDomain &&
    authDomain !== 'your_project_id.firebaseapp.com' &&
    projectId &&
    projectId !== 'your_project_id'
  );
};

// Initialize Firebase and Auth with fallback for development
let app: FirebaseApp;
let auth: Auth;

if (hasValidFirebaseConfig()) {
  // Initialize with real config when valid
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };

  //console.log("Firebase config: " + JSON.stringify(firebaseConfig));

  app = initializeApp(firebaseConfig);
  auth = getAuth(app);

  //console.log("Firebase initialized with production configuration");
} else {
  // If no valid config is found, create a minimal app for development
  // This allows the rest of the app to work without Firebase Auth
  console.warn(
    'Firebase configuration is missing or invalid. ' +
      'Authentication features will be disabled. ' +
      'Please update your environment variables with valid Firebase credentials.'
  );

  // Initialize with a minimal config that won't crash
  const fallbackConfig = {
    apiKey: 'demo-key-for-development',
    authDomain: 'demo-project.firebaseapp.com',
    projectId: 'demo-project',
  };

  app = initializeApp(fallbackConfig);
  auth = getAuth(app);

  // In development, we can use a local auth emulator or mock
  // This prevents API calls to Firebase when credentials aren't set
  if (import.meta.env.DEV) {
    // This is a development fallback that doesn't make real Firebase calls
    // The actual auth operations will be no-ops or return mock data
  }
}

export { auth };
export default app;
